module.exports = __webpack_public_path__ + "media/images/substained-abuse-graph-2023-03527b6b810dc92b44eec838f9601814.svg";